var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7218 10.2778L9.72179 15.2778C8.34108 16.6585 6.1025 16.6585 4.72179 15.2778C3.34108 13.8971 3.34108 11.6585 4.72179 10.2778L11.2496 3.75C12.0933 2.90623 13.4614 2.90623 14.3051 3.75C15.1489 4.59377 15.1489 5.96179 14.3051 6.80556L7.77734 13.3333C7.47052 13.6402 6.97306 13.6402 6.66623 13.3333C6.35941 13.0265 6.35941 12.529 6.66623 12.2222L11.6581 7.23036C11.9649 6.92353 11.9649 6.42607 11.6581 6.11925C11.3513 5.81242 10.8538 5.81242 10.547 6.11925L5.55512 11.1111C4.63465 12.0316 4.63465 13.524 5.55512 14.4444C6.4756 15.3649 7.96798 15.3649 8.88845 14.4444L15.4162 7.91667C16.8737 6.45925 16.8737 4.09631 15.4162 2.63889C13.9588 1.18147 11.5959 1.18147 10.1385 2.63889L3.61068 9.16667C1.61632 11.161 1.61632 14.3945 3.61068 16.3889C5.60504 18.3833 8.83854 18.3833 10.8329 16.3889L15.8329 11.3889C16.1397 11.0821 16.1397 10.5846 15.8329 10.2778C15.5261 9.97095 15.0286 9.97095 14.7218 10.2778Z",
    fill: "#3288CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.b3fe3dc7b8720067c1f9c54fe277a7ce.svg";
export { ForwardRef as ReactComponent };